import { Image } from '@gousto-internal/citrus-react'
import React from 'react'
import ecofriendlyBoxjpg from '../../../assets/EnviromentalBenefitsSectionAssets/EcoChillBox.jpg'
import ecofriendlyBoxWeb from '../../../assets/EnviromentalBenefitsSectionAssets/EcoChillBox.webp'

export const EcoChillBoxImage = () => (
  <Image fit="cover" alt="" srcSet={ecofriendlyBoxWeb} src={ecofriendlyBoxjpg} />
)
